(function(){
  if(!window.location.pathname.includes('/products/'))return;
  var handle=window.location.pathname.match(/\/products\/([^/?#]+)/);
  if(!handle)return;
  var productData=null,variantMap={};

  fetch('/products/'+handle[1]+'.js').then(function(r){return r.json();}).then(function(data){
    productData=data;
    buildVariantMap(data);
    applyFilter();
  });

  function buildVariantMap(data){
    var imgs=data.images;
    variantMap={};
    var anchors=[];
    imgs.forEach(function(img,idx){
      if(img.variant_ids&&img.variant_ids.length>0){
        img.variant_ids.forEach(function(vid){
          anchors.push({idx:idx,vid:String(vid)});
        });
      }
    });
    anchors.sort(function(a,b){return a.idx-b.idx;});
    if(!anchors.length)return;
    var claimed=new Array(imgs.length).fill(false);
    anchors.forEach(function(anchor,i){
      var vid=anchor.vid;
      if(!variantMap[vid])variantMap[vid]=new Set();
      var start=i>0?anchors[i-1].idx+1:0;
      for(var j=start;j<anchor.idx;j++){
        if(!claimed[j]){variantMap[vid].add(String(imgs[j].id));claimed[j]=true;}
      }
      variantMap[vid].add(String(imgs[anchor.idx].id));
      claimed[anchor.idx]=true;
      var nextAnchorIdx=i+1<anchors.length?anchors[i+1].idx:imgs.length;
      for(var k=anchor.idx+1;k<nextAnchorIdx;k++){
        if(!claimed[k]&&(!imgs[k].variant_ids||imgs[k].variant_ids.length===0)){
          variantMap[vid].add(String(imgs[k].id));claimed[k]=true;
        }
      }
    });
  }

  function applyFilter(){
    var v=new URLSearchParams(window.location.search).get('variant');
    var items=document.querySelectorAll('[data-media-id]');
    if(!v||!productData){items.forEach(function(el){el.style.display='';});return;}
    var allowed=variantMap[v];
    if(!allowed){items.forEach(function(el){el.style.display='';});return;}
    items.forEach(function(el){
      var m=el.getAttribute('data-media-id').match(/(\d+)$/);
      if(!m)return;
      el.style.display=allowed.has(m[1])?'':'none';
    });
  }

  function patch(){
    var op=history.pushState.bind(history),or=history.replaceState.bind(history);
    history.pushState=function(){op.apply(this,arguments);setTimeout(applyFilter,150);};
    history.replaceState=function(){or.apply(this,arguments);setTimeout(applyFilter,150);};
    window.addEventListener('popstate',function(){setTimeout(applyFilter,150);});
  }

  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',patch);}
  else{patch();}
})();